const eventKeys = [
    'ev',
    'aid',
    'bid',
    'st',
    'n',
    'sid',
    'cpm',
    'pb',
    'cry',
    'net',
    'did',
    'cid',
    'sz',
    'ttr',
    'lid',
    'dsp',
    'adv',
    'bri',
    'brn',
    'add',
];
export { eventKeys };
